import { useEffect, useState } from "react";
import { getMyPlaylists } from "@sharpana/auth/api_client/summarization_api";
import {
  centeredUrlRequestContainer,
  playlistsContainer,
} from "./my_playlists_styles";
import { SummarizationURLRequest } from "./SummarizationURLRequest";
import { Playlist, PlaylistsResponse } from "@sharpana/auth/api_client/summarization_api";
import { InvitationToConnectPlaylist } from "./MyPlaylists";
import { secondaryButtonStyle } from "./summarization_request_styles";
import { useNavigate } from "react-router-dom";


export const StartNewRequest = () => {
  const [playlists, setPlaylists] = useState<Playlist[]>([]);
  const [loading, setLoading] = useState(true);
  const [totalPlaylists, setTotalPlaylists] = useState(0);
  const navigate = useNavigate();

  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const pageSize = 15;

  const fetchData = async (page: number) => {
    try {
      setLoading(true);
      const [playlistsResponse] = await Promise.all([
        getMyPlaylists(page, pageSize) as Promise<PlaylistsResponse>,
      ]);

      if (playlistsResponse.error) {
        throw new Error(playlistsResponse.error);
      }

      setPlaylists(playlistsResponse.results || []);
      setTotalPlaylists(playlistsResponse.total || 0);
    } catch (error) {
      console.error("Failed to fetch data:", error);
      //   message.error("Failed to load content. Please try again later.");
      setPlaylists([]);
      setTotalPlaylists(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, [refreshTrigger]);

  const refreshPlaylists = () => {
    // Increment the refresh trigger to cause a re-fetch
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div css={playlistsContainer}>
      <div css={centeredUrlRequestContainer()}>
        <SummarizationURLRequest />
      </div>

      {playlists.length === 0 && !loading ? (
        <InvitationToConnectPlaylist refreshPlaylists={refreshPlaylists} />
      ) : (
        playlists.length > 0 && (
          <div 
            css={secondaryButtonStyle} 
            onClick={() => navigate("/")}
          >
            My Collection
          </div>
        )
      )}
    </div>
  );
};
